export default [{
  state: 'fourOFour',
  config: {
    url: '/404',
    component: 'fourOFour',
  },
}];



// WEBPACK FOOTER //
// ./src/app/four-o-four/four-o-four.routes.js